import script from "./BuildingDetailsMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuildingDetailsMobile.vue?vue&type=script&lang=ts&setup=true"

import "./BuildingDetailsMobile.vue?vue&type=style&index=0&id=5f105537&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f105537"]])

export default __exports__